// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"278":"infobox","663":"credits"}[chunkId] + "." + {"278":"5c4bdc00","663":"7a024255"}[chunkId] + ".css";
};